<template>
  <div class="tw-mt-2 tw-mb-1 tw-font-normal tw-text-sm tw-text-center">
    <a
      class="hover:tw-underline link-color-brand"
      :href="url"
      rel="noopener noreferrer"
      target="_blank"
      @click="($event) => $emit('click', $event)"
    >
      How to read this data
      <font-awesome-icon
        class="tw-ml-1"
        :icon="['far', 'info-circle']"
      />
    </a>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useMetaStore } from '@@/stores/Meta';
import { useUserStore } from '@@/stores/User';

export default {
  name: 'SnowForecastTableFooter',

  props: {
    field: {
      type: String,
      required: true,
    },
    sourceId: {
      type: Number,
      required: true,
    },
  },

  emits: ['click'],

  computed: {
    ...mapState(useMetaStore, ['getAttributionDetailUrl']),

    ...mapState(useUserStore, {
      units: (state) => state.preferences.units,
    }),

    url() {
      return this.getAttributionDetailUrl(this.sourceId, this.field) || '#';
    },
  },
};
</script>
